import React, { useEffect, useState } from 'react';
import { CardElement, useStripe, useElements } from '@stripe/react-stripe-js';
import Dropdown from '../components/commons/Dropdown'
import TextInput from './commons/TextInput';
import { useAtom } from 'jotai';
import { showAddPaymentMethodAtom, userAtom } from '../store';
import axios from 'axios';
import { updateUserProfile } from '../firebase/users';
import { getAuthHeaders } from '../firebase/authHeaders';
import { useAuth } from '../context/authContext';
import DialogConfirmation from './dialogs/DialogConfirmation';
// import { payment } from 'paypal-rest-sdk';

const PaymentForm = () => {
    const stripe = useStripe();
    const elements = useElements();
    const [cardHolder, setCardHolder] = useState('');
    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(null);
    const [selectedMethod, setSelectedMethod] = useState('card')
    const [userData, setUserData] = useAtom(userAtom)
    const [accountHolderType, setAccountHolderType] = useState('individual')
    const [routingNumber, setRoutingNumber] = useState(null)
    const [accountNumber, setAccountNumber] = useState(null)
    const [accountHolderName, setAccountHolderName] = useState(null)
    const [showConfirmModal, setShowConfirmModal] = useState(false)
    const [showFailedModal, setShowFailedModal] = useState(false)
    const [showAddPaymentMethod, setShowAddPaymentMethod] = useAtom(showAddPaymentMethodAtom)
    const { getUpdatedUserData } = useAuth()

    const accountHolderTypes = [
        {
            label: 'Individual',
            value: 'individual'
        },
        {
            label: 'Company',
            value: 'company'
        }
    ]

    useEffect(() => {
        if (stripe && userData && !userData.payment) {
            createPaymentCustomer()
        }
    }, [stripe])

    const createPaymentCustomer = async () => {
        axios({
            method: 'post',
            url: process.env.REACT_APP_PAYMENT_API + '/create-customer',
            headers: await getAuthHeaders(),
            data: {
                name: userData.username
            }
        }).then(async ({ data }) => {
            await updateUserProfile(userData.id, { payment: { customer_id: data.account.id } })
            await getUpdatedUserData()
        }).catch((error) => {
            console.log(error)
        })
    }

    const connectCard = async (event) => {
        event.preventDefault();

        if (!stripe || !elements || !userData.payment) {
            return; // Stripe.js has not yet loaded.
        }

        const cardElement = elements.getElement(CardElement);

        // Create a payment method
        const { error, paymentMethod } = await stripe.createPaymentMethod({
            type: 'card',
            card: cardElement,
            billing_details: {
                name: cardHolder,
            },
        });

        if (error) {
            setError(error.message);
            setSuccess(null);
        } else {
            axios({
                method: 'post',
                url: process.env.REACT_APP_PAYMENT_API + '/connect-card',
                headers: await getAuthHeaders(),
                data: {
                    paymentMethodId: paymentMethod.id,
                    customerId: userData.payment.customer_id
                }
            }).then(async () => {
                await updateUserProfile(userData.id, { payment: { ...userData.payment, card: paymentMethod.card } })
                await getUpdatedUserData()
                setShowConfirmModal(true)
                // setShowAddPaymentMethod(false)
            }).catch((error) => {
                setShowFailedModal(true)
            })
        }
    };

    const connectBank = async () => {
        axios({
            method: 'post',
            url: process.env.REACT_APP_PAYMENT_API + '/create-bank-account',
            headers: await getAuthHeaders(),
            data: {
                customerId: userData.payment.customer_id,
                bankDetails: {
                    country: "US",
                    currency: "USD",
                    accountHolderName: accountHolderName,
                    accountHolderType: accountHolderType,
                    routingNumber: routingNumber,
                    accountNumber: accountNumber
                }
            }
        }).then(async ({ data }) => {
            await updateUserProfile(userData.id, { payment: { ...userData.payment, bank: data.bankAccount } })
            await getUpdatedUserData()
            // setShowAddPaymentMethod(false)
            setShowConfirmModal(true)
        }).catch(() => {
            setShowFailedModal(true)
        })
    }

    return (
        <>
            <DialogConfirmation
                message="Your payment method has been added!"
                open={showConfirmModal}
                onClose={() => setShowConfirmModal(false)}
                buttonText="Done"
                title="Method Added"
                iconSrc="/assets/icons/icon-check-circle.svg"
                type="confirm"
            />

            <DialogConfirmation
                message="An error occured. Please try again."
                open={showFailedModal}
                onClose={() => setShowFailedModal(false)}
                buttonText="Try Again"
                title="Failed Adding"
                iconSrc="/assets/icons/icon-check-circle.svg"
                type="confirm"
            />

            <div className='relative px-12 py-10 text-white'>
                <h1 className='text-white text-[34px]'>Add Method</h1>
                <button className='absolute right-4 top-4' onClick={() => setShowAddPaymentMethod(false)}>
                    <img src='/assets/icons/icon-close-white.svg' alt='close' />
                </button>

                <div className='mt-5 mb-5 text-xs'>Select Method*</div>

                <div className='flex mb-8'>
                    <button className='text-center mr-3' onClick={() => setSelectedMethod('card')}>
                        <div className={`flex justify-center items-center border-[1px] bg-[#232323] w-[116px] h-[54px] rounded-[4px] ${selectedMethod === 'card' ? 'border-primary' : ' border-gray'}`}>
                            {
                                selectedMethod === 'card' ?
                                    <img src='/assets/icons/icon-credit-card-primary.svg' alt='card' />
                                    :
                                    <img src='/assets/icons/icon-credit-card-white.svg' alt='card' />
                            }
                        </div>

                        <span className={`text-xs font-thin ${selectedMethod === 'card' ? 'text-primary' : 'text-white'}`}>Debit Card</span>
                    </button>

                    <button className='text-center mr-3' onClick={() => setSelectedMethod('bank')}>
                        <div className={`flex justify-center items-center border-[1px] bg-[#232323] w-[116px] h-[54px] rounded-[4px] ${selectedMethod === 'bank' ? 'border-primary' : ' border-gray'}`}>
                            {
                                selectedMethod === 'bank' ?
                                    <img src='/assets/icons/icon-bank-primary.svg' alt='bank' />
                                    :
                                    <img src='/assets/icons/icon-bank-white.svg' alt='bank' />
                            }
                        </div>

                        <span className={`text-xs font-thin ${selectedMethod === 'bank' ? 'text-primary' : 'text-white'}`}>Bank</span>
                    </button>
                </div>

                {
                    selectedMethod === 'card' ?
                        userData.payment?.card ?
                            <div>
                                Debit Card has been added
                            </div>
                            :
                            <>
                                <div className='mb-4 text-xs'>Card holder*</div>

                                <form onSubmit={connectCard} className='card-form'>
                                    <input
                                        type="text"
                                        placeholder="Yuliia Parker"
                                        value={cardHolder}
                                        onChange={(e) => setCardHolder(e.target.value)}
                                        required
                                        className='mb-3'
                                    />
                                    <CardElement options={{
                                        classes: {
                                            base: 'card-payment-form'
                                        },
                                        style: {
                                            base: {
                                                color: '#fff',
                                                fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
                                                fontSmoothing: 'antialiased',
                                                fontSize: '16px',
                                                lineHeight: '24px',
                                                padding: '10px',
                                                '::placeholder': {
                                                    color: '#aab7c4',
                                                },
                                            },
                                            invalid: {
                                                color: '#fa755a',
                                                iconColor: '#fa755a',
                                            },
                                            complete: {
                                                color: '#4caf50',
                                            },
                                        },
                                        disableLink: true,
                                        hidePostalCode: true
                                    }} />

                                    {/* {error && <div>{error}</div>}
                                {success && <div>{success}</div>} */}

                                    <p className='text-[#848484] text-[13px] my-5'>
                                        By selecting "Connect Method", you acknowledge and agree to Cardmarketplace's <span className='underline'>Terms of Service</span> and authorize Cardmarketplace to send payment to your designated card/bank.
                                    </p>

                                    <button type="submit" disabled={!stripe} className='mt-3 h-[55px] flex justify-center items-center w-full bg-primary text-[18px] rounded-[6px]'>
                                        <img src='/assets/icons/icon-shield-white.svg' alt='shield' className='mr-1' />
                                        Connect Method
                                    </button>
                                </form>

                                <div className='mt-5 text-[#848484] flex justify-center text-sm'>
                                    <img src='/assets/icons/icon-unlocked-gray.svg' alt='unlocked' className='mr-2' />

                                    Infomation is protected and kept confidential
                                </div>
                            </>
                        :
                        userData.payment?.bank ?
                            <div>
                                Bank has been added
                            </div>
                            :
                            <>
                                <div className='mb-3 text-sm'>Account Type</div>

                                <Dropdown
                                    options={accountHolderTypes}
                                    className="border-[1px] border-gray text-sm rounded-[6px]"
                                    onChange={(v) => setAccountHolderType(v)}
                                />

                                <div className='mb-3 mt-5 text-sm'>Routing Number</div>

                                <TextInput
                                    placeholder="Routing Number"
                                    inputClassName="placeholder:text-white/60 text-sm"
                                    type="number"
                                    value={routingNumber}
                                    onChange={(v) => setRoutingNumber(v)}
                                />

                                <div className='mb-3 mt-5 text-sm'>Account Number</div>

                                <TextInput
                                    placeholder="Account Number"
                                    inputClassName="placeholder:text-white/60 text-sm"
                                    type="number"
                                    value={accountNumber}
                                    onChange={(v) => setAccountNumber(v)}
                                />

                                <div className='mb-3 mt-5 text-sm'>Account Holder's Name</div>

                                <TextInput
                                    inputClassName="placeholder:text-white/60 text-sm"
                                    value={ accountHolderName}
                                    onChange={(v) => setAccountHolderName(v)}
                                />

                                <p className='text-[#848484] text-[13px] my-5'>
                                    By selecting "Connect Method", you acknowledge and agree to Cardmarketplace's <span className='underline'>Terms of Service</span> and authorize Cardmarketplace to send payment to your designated card/bank.
                                </p>

                                <button type="submit" disabled={!stripe} className='mt-3 h-[55px] flex justify-center items-center w-full bg-primary text-[18px] rounded-[6px]' onClick={connectBank}>
                                    <img src='/assets/icons/icon-shield-white.svg' alt='shield' className='mr-1' />
                                    Connect Method
                                </button>

                                <div className='mt-5 text-[#848484] flex justify-center text-sm'>
                                    <img src='/assets/icons/icon-unlocked-gray.svg' alt='unlocked' className='mr-2' />

                                    Infomation is protected and kept confidential
                                </div>
                            </>
                }
            </div>
        </>
    );
};

export default PaymentForm;
